import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { userClientListPropTypes } from '../propTypes/userClients';

class CheckboxRenderer extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    checkedClientsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
    editableClientId: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    readOnly: PropTypes.bool,
    clients: userClientListPropTypes.isRequired,
  };

  onChange = event => {
    this.props.onChange(
      this.props.value,
      event.target.checked
    );
  };

  render() {
    const {
      checkedClientsIds,
      editableClientId,
      value,
      readOnly,
      clients,
    } = this.props;

    const client = clients.find(client => client.clientId === value);
    const canEdit = client && client.canEdit;

    return (
      <input
        type="checkbox"
        checked={checkedClientsIds.includes(value)}
        name="isSelected"
        onChange={this.onChange}
        disabled={readOnly || !canEdit || editableClientId !== value}
      />
    );
  }
}

export default () => props => <CheckboxRenderer {...props} />; // eslint-disable-line react/display-name
